export default __webpack_public_path__ + "static/media/IQ.0a65cbf8.ico";